import { render, staticRenderFns } from "./createdTest.vue?vue&type=template&id=62c46ee6&scoped=true&"
import script from "./createdTest.vue?vue&type=script&lang=js&"
export * from "./createdTest.vue?vue&type=script&lang=js&"
import style0 from "./createdTest.vue?vue&type=style&index=0&id=62c46ee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c46ee6",
  null
  
)

export default component.exports